/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { GlobalConstants } from '../../../../feature/src/lib/constants/global-constants';
import { DotNetRequestMessageService } from '@mep/web-browser-bridge';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

/**
 * Represents a service for handling SysQue Gauge events.
 */
export class SysQueGaugeService {

  /**
   * Creates an instance of SysQueGaugeService.
   * @param messageHandler The message handler service for sending requests.
   */
  constructor(private messageHandler: DotNetRequestMessageService) {}

  /**
   * Closes the window.
   */
  public closeWindow(): Observable<any> {
    return from<Promise<any>>(this.messageHandler.sendRequestAsync(GlobalConstants.OnCloseWindow));
  }

  /**
   * Rotates the SysQue connect.
   * @param angle The angle to rotate.
   */
  public rotateSysQueConnect(angle: string): Observable<any> {
    return from<Promise<any>>(this.messageHandler.sendRequestAsync(GlobalConstants.RotateSysQueConnect, [angle]));
  }

  /**
   * Initializes the SysQue gauge.
   */
  public initializeSysQueGauge(): Observable<any> {
    return from<Promise<any>>(this.messageHandler.sendRequestAsync(GlobalConstants.InitializeSysQueGauge));
  }

  /**
   * Retrieves the SysQue Connect fitting variables.
   * @returns A promise that resolves to an array of strings representing the SysQue Connect fitting variables.
   */
  public getSysQueConnectFittingVariables(): Promise<string[]> {
    return this.messageHandler.sendRequestAsync(GlobalConstants.GetSysQueConnectFittingVariables);
  }

   /**
   * Retrieves the system name of the selected element.
   * 
   * @returns A promise that resolves to a string representing the system name of the selected element.
   */
   public getSelectedElementSystemName(): Promise<string> {
    return this.messageHandler.sendRequestAsync(GlobalConstants.GetSelectedElementSystemName);
  }
}
